<template>
  <div class="goods">
    <van-nav-bar title="提交成功" left-arrow @click-left="onClickLeft" style="height: 1.28rem"/>

    <div style="text-align: center;font-size: .378rem;color: #999;line-height: .574rem;">
      <div class="flex-center" style="margin: 2.7rem auto 1.28rem;width: 1.836rem;height: 1.836rem;background:linear-gradient(135deg,rgba(255,180,180,1),rgba(249,95,95,1));border-radius:60%;color: #fff">
        <van-icon name="success" style="font-size: .972rem;"/>
      </div>
      <div>
        <div style="color: #333;font-size: .486rem;margin-bottom: .54rem">您的信息已提交成功！</div>
        <div>平台会在30分钟内与您联系，确认核实卖车信息</div>
        <div>(工作时间：09:00-21:00）</div>
      </div>
      <div class="flex-center" style="margin-top: 1.28rem;">
        <a class="flex-center" style="color: #e9081a;border: 1px solid #e9081a;font-size: .432rem;height: 1.188rem;width: 2.997rem;border-radius: .574rem;">知道了</a>
      </div>
    </div>

  </div>
</template>

<script>
    import {
        NavBar,
        Tag,
        Col,
        Icon,
        Cell,
        CellGroup,
        Swipe,
        Toast,
        SwipeItem,
        GoodsAction,
        GoodsActionIcon,
        GoodsActionButton
    } from 'vant';

    export default {
        components: {
            [NavBar.name]: NavBar,
            [Tag.name]: Tag,
            [Col.name]: Col,
            [Icon.name]: Icon,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Swipe.name]: Swipe,
            [SwipeItem.name]: SwipeItem,
            [GoodsAction.name]: GoodsAction,
            [GoodsActionIcon.name]: GoodsActionIcon,
            [GoodsActionButton.name]: GoodsActionButton
        },

        data() {
            return {
                goods: {
                    list:[
                        {name:"填写信息",icon:"coupon-o"},
                        {name:"提交/审核",icon:"location-o"},
                        {name:"平台售卖",icon:"shopping-cart-o"},
                        {name:"车辆交易",icon:"gem-o"}
                    ]
                }
            };
        },

        methods: {
            onClickLeft() {
                this.$router.push('/SellCars');
            }
        }
    };
</script>

<style lang="less">
  .goods {
    padding-bottom: 50px;

    &-swipe {
      img {
        width: 100%;
        display: block;
      }
    }

    &-title {
      font-size: 16px;
    }

    &-price {
      color: #f44;
    }

    &-express {
      color: #999;
      font-size: 12px;
      padding: 5px 15px;
    }

    &-cell-group {
      margin: 15px 0;

      .van-cell__value {
        color: #999;
      }
    }

    &-tag {
      margin-left: 5px;
    }
  }

  body{
    background: #fff;
  }
  .flex-start{
    display:flex;
    flex-direction: row;
    align-items:center;
    justify-content:flex-start;
  }
  .flex-center{
    display:flex;
    flex-direction: row;
    align-items:center;
    justify-content:center;
  }
  .flex-column{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .van-nav-bar__title{
    font-size: .486rem;
    color: #333;
  }
  .van-nav-bar .van-icon{
    font-size: .486rem;
    color: #333;
  }
</style>
